"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.BathroomAmenitiesDto = void 0;
var class_validator_1 = require("class-validator");
var BathroomAmenitiesDto = (function () {
    function BathroomAmenitiesDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn([
            'PRIVATE_BATHROOM',
            'PRIVATE_BATHROOM_OUTSIDE',
            'PARTIALLY_OPEN_BATHROOM',
            'SHARED_BATHROOM_WITH_SINK_IN_ROOM',
        ]),
        __metadata("design:type", String)
    ], BathroomAmenitiesDto.prototype, "primaryBathroom");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        class_validator_1.Min(0),
        __metadata("design:type", Number)
    ], BathroomAmenitiesDto.prototype, "numberOfBathrooms");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "bathrobes");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "childrenBathrobes");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "heatedFloor");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "freeToiletries");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "designerToiletries");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "soap");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "shampoo");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "toiletPaper");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "hairDryer");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "bidet");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['SHOWER', 'BATHTUB', 'BATHTUB_OR_SHOWER', 'SEPARATE_BATHTUB_AND_SHOWER', 'SHOWER_TUB_COMBINATION']),
        __metadata("design:type", String)
    ], BathroomAmenitiesDto.prototype, "bathType");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        class_validator_1.IsIn(['STANDARD_BATHTUB', 'DEEP_SOAKING_BATHTUB', 'JETTED_BATHTUB', 'SPRING_WATER_BATHTUB']),
        __metadata("design:type", String)
    ], BathroomAmenitiesDto.prototype, "bathtubType");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "hydroMassageShowerhead");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], BathroomAmenitiesDto.prototype, "rainfallShowerhead");
    return BathroomAmenitiesDto;
}());
exports.BathroomAmenitiesDto = BathroomAmenitiesDto;
//# sourceMappingURL=bathroom-amenities.dto.js.map